// Types for Generate Rides Drawer and subcomponents

export type SimulationType = 'excel' | 'bulk' | 'p2p' | 'p2h';
export type RidesSource = 'layer' | 'upload' | 'generate';

export interface Peak {
  peak_time: string;
  effect: number;
  width_left: number;
  width_right: number;
} 